import { createContext, useContext } from 'react';

export const LocaleContext = createContext();

export function useLocaleContext() {
  console.log("useLocaleContext");
  return useContext(LocaleContext);
}
